// extracted by mini-css-extract-plugin
export default {"f":"c7338cb1fc","main":"_064c98848e","btn":"b9bff19e92","w":"_06f251296a","h":"_20760d05e1","lh25":"_62d9dd2bcf","wb":"d388b8cf9e","b":"_27238cab94","bx":"_85452d5a37"};